import {Button, Row, Space, Typography, Col, Input, Form, Select} from "antd";
import React, {useEffect, useState} from "react";
import Icons from "assets/icons";
import "./IntraocularExpand.scss";

import {listMethodIntraocularPressure} from "pages/NurseOut/DetailPatient/components/NurseInfo/config";
import {useAppSelector} from "redux/hooks";
import {formatDateToString} from "helper/common";
import moment from "moment";
import {FORMAT_TIME} from "types/enums";

type Props = {
  isOpen: boolean;
  setIsOpen: () => void;
  index: number;
  form?: any;
};

type Item = {
  key: number;
  index: number;
  action: "add" | "remove";
};

const IntraocularExpand: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  index,
  form,
}) => {
  const objectChanDoan = useAppSelector(
    state => state.examination.objectChanDoan
  );
  const ref = useAppSelector(state => state.examination.ref);
  const name = index == 1 ? "leftJsonValue" : "rightJsonValue";
  const dataPhieu = useAppSelector(state => state.examination.dataPhieu);

  useEffect(() => {
    if (!isOpen) {
      // const fieldsValue = ref.getChanDoanValue();
      if (ref) {
        ref.setFieldValue([name, "INTRAOCULAR_PRESSURE"], null);
      }
    }
    if (ref) {
      ref.setFieldValue([name, "INTRAOCULAR_PRESSURE", "show"], isOpen);
    }
  }, [isOpen, ref]);
  useEffect(() => {}, [dataPhieu]);
  useEffect(() => {
    if (objectChanDoan && ref) {
      const show = ref.getFieldValue([name, "INTRAOCULAR_PRESSURE", "show"]);
      if (Boolean(show) == true && isOpen == false) {
        setIsOpen();
      }
      if (Boolean(show) == false && isOpen == true) {
        setIsOpen();
      }
      const formList = ref.getFieldValue([
        name,
        "INTRAOCULAR_PRESSURE",
        "formList",
      ]);
      if (!formList || !formList.length) {
        ref.setFieldValue(
          [name, "INTRAOCULAR_PRESSURE", "formList"],
          [{mmHg: "", min: "", method: ""}]
        );
      }
    }
  }, [objectChanDoan, ref]);
  return (
    <Space
      direction="vertical"
      className="space-common space-intraocular"
      size={"small"}
    >
      <Row justify={"start"} className="row-common">
        <Button
          type="primary"
          icon={isOpen ? <Icons.sub /> : <Icons.add />}
          onClick={setIsOpen}
        />
        <Typography className="title-common-healthy">NHÃN ÁP</Typography>
      </Row>
      {isOpen && (
        <div>
          <div className="form-list">
            <Form.List
              name={[name, "INTRAOCULAR_PRESSURE", "formList"]}
              initialValue={[{mmHg: "", min: "", method: ""}]}
            >
              {(fields, {add, remove}, {errors}) => (
                <>
                  <Row justify={"end"}>
                    {" "}
                    <Button
                      size="small"
                      type="primary"
                      onClick={() => {
                        add({
                          mmHg: "",
                          min: "",
                          method: "",
                        });
                      }}
                      style={{marginBottom: 8}}
                    >
                      Thêm lần đo
                    </Button>
                  </Row>

                  {fields.map((field, idx) => (
                    <>
                      <Row gutter={[16, 16]}>
                        <Col flex={"120px"}>
                          Giá trị{" "}
                          <span style={{marginLeft: "4px"}}>
                            <Button
                              size="small"
                              type="primary"
                              danger
                              onClick={() => {
                                remove(idx);
                              }}
                            >
                              <Icons.sub></Icons.sub>
                            </Button>
                          </span>
                        </Col>
                        <Col flex={"auto"}>
                          <Space>
                            <Form.Item name={[field.name, "mmHg"]}>
                              <Input
                                suffix="mmHG"
                                onChange={e => {
                                  console.log(field.name);
                                  ref.setFieldValue(
                                    [
                                      name,
                                      "INTRAOCULAR_PRESSURE",
                                      "formList",
                                      field.name,
                                      "min",
                                    ],
                                    formatDateToString(
                                      moment(),
                                      FORMAT_TIME.dateTime
                                    )
                                  );
                                }}
                              ></Input>
                            </Form.Item>

                            <Form.Item name={[field.name, "min"]}>
                              <Input
                                prefix="Lúc"
                                suffix={<Icons.clock />}
                              ></Input>
                            </Form.Item>
                          </Space>
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]}>
                        <Col flex={"120px"}>Phương pháp đo</Col>
                        <Col flex={"auto"}>
                          <Form.Item name={[field.name, "method"]}>
                            <Select options={listMethodIntraocularPressure} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  ))}
                </>
              )}
            </Form.List>
          </div>
          <Row>
            <Col span={24}>
              <Row gutter={[16, 8]}>
                <Col flex={"120px"}>Ghi chú</Col>
                <Col flex={"auto"}>
                  <Form.Item
                    name={[
                      `${index == 0 ? "rightJsonValue" : "leftJsonValue"}`,
                      "INTRAOCULAR_PRESSURE",
                      "Comment",
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    style={{display: "none"}}
                    name={[
                      `${index == 0 ? "rightJsonValue" : "leftJsonValue"}`,
                      "INTRAOCULAR_PRESSURE",
                      "show",
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              {/* <DataInputField
                itemScale={{first: 6, second: 18}}
                label="Ghi chú"
                children={
                  <Input
                    suffix={
                      <Icon
                        
                        style={{fontSize: "24px"}}
                        component={
                          Icons.file as React.ForwardRefExoticComponent<any>
                        }
                      />
                    }
                    className="data-input-intraocular2"
                  />
                }
              /> */}
            </Col>
          </Row>
        </div>
      )}

      {/* {true ? (
       
      ) : null} */}
    </Space>
  );
};

export default IntraocularExpand;
